import { Model, attr, Session, fk } from 'redux-orm';
import { IORMModels, ISession } from 'src/Config/ConfigureOrm';
import { AppAction } from 'src';
import {
  GET_ACTIVITY_DETAILS_SUCCEEDED,
  GET_ACTIVITY_DETAILS_FAILED
} from './Activity.Actions';
import { ITagProps } from 'src/components/Tag';
import { IPortalState } from '../PortalState/PortalState';

export interface ISubActivityModel {
  lektionId: number;
  name: string;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  location?: string;
  isSleepOver: boolean;
  detailKursusId: number;
}

export interface IActivityModel {
  detailKursusId: number;
  courseTitle: string;
  fiuNo: string;
  admStatus: string;
  startDate: string;
  startTime: string;
  endDate: string;
  endTime: string;
  courseLocation: string;
  isFocus: boolean;
  isAdvertisement: boolean;
  signUpForm: string;
  filterFromCourseCarousel: boolean;
  tag?: ITagProps;
  subActivities?: ISubActivityModel[];
  FewSpotsLeft?: boolean;
  spotsLeft: number;
  description: string;
  teaserText?: string;
  isInternal: boolean;
  lastEnrollmentDate: string;
  lastEnrollmentDateEndTime: string;
  createdDate: string;
  publicationDate: string;
  courseSpecialNote: string;
  contactInfoName?: string;
  contactInfoPhone?: string;
  contactInfoMail?: string;

  GetStartDateFormattedString?: string;
  GetFormattedFiuNo: string;
  categoryId: number;
}

export default class Activity extends Model<IActivityModel>
  implements IActivityModel {
  public static modelName = 'Activity';
  public static fields = {
    activityId: attr({}),
    categoryId: attr({})
  };
  public static reducer(
    action: AppAction<any>,
    activity: typeof Model,
    session: ISession<IORMModels>
  ) {
    switch (action.type) {
      case GET_ACTIVITY_DETAILS_SUCCEEDED:
        session.PortalState.upsert<IPortalState>({
          id: 0,
          SelectedActivity: activity.upsert<IActivityModel>(action.payload),
        });
        break;

      case GET_ACTIVITY_DETAILS_FAILED:
        console.error('Activity failed');
        break;
    }
  }
  public detailKursusId: number;
  public courseTitle: string;
  public fiuNo: string;
  public admStatus: string;
  public startDate: string;
  public endDate: string;
  public signUpForm: string;
  public startTime: string;
  public endTime: string;
  public courseLocation: string;
  public isFocus: boolean;
  public isAdvertisement: boolean;
  public filterFromCourseCarousel: boolean;
  public tag: ITagProps;
  public FewSpotsLeft?: boolean;
  public spotsLeft: number;
  public description: string;
  public teaserText?: string;
  public isInternal: boolean;
  public subActivities?: ISubActivityModel[];
  public contactInfoName?: string;
  public contactInfoPhone?: string;
  public contactInfoMail?: string;
  public lastEnrollmentDate: string;
  public lastEnrollmentDateEndTime: string;
  public createdDate: string;
  public publicationDate: string;
  public courseSpecialNote: string;
  public categoryId: number;

  public get GetStartDateFormattedString(): string {
    return this.startDate.toString();
  }

  public get GetFormattedFiuNo(): string {
    const seperator = '-';
    const formattedNo = [
      this.fiuNo.slice(0, 4),
      seperator,
      this.fiuNo.slice(4, 6),
      seperator,
      this.fiuNo.slice(6, 8),
      seperator,
      this.fiuNo.slice(8, 10)
    ].join('');

    return formattedNo;
  }
}



// WEBPACK FOOTER //
// ./src/Entities/Activity/Activity.ts